import React from "react";
import "./ProductsPage.css";

const ProductsPage = () => {
  return (
    <div className="products-page">
      <header className="products-header">
        <h1>Our Products</h1>
        <p>Explore the powerful tools we offer to help you dominate the vehicle auction space.</p>
      </header>

      <section className="product-card" >
        <div className="product-info">
          <h2>CRM Platform</h2>
          <p>
            Our CRM gives you full control over your dealers' access and activity on Copart and IAAI auctions. Easily manage users, monitor bidding behavior, and review complete bid histories. For advanced features and integration details, please <a href="#contact">contact our team</a>.
          </p>
        </div>
        <img src="/static/04.png" alt="CRM Platform" className="product-image" />
      </section>

      <section className="product-card vertical-img">
        <img src="/static/05.png" alt="Mobile App" className="product-image" />
        <div className="product-info">
          <h2>Mobile Application (iOS & Android)</h2>
          <p>
            Empower your dealers to participate in the most popular U.S. vehicle auctions directly from their smartphones. With real-time bidding (live or pre-bid), individual watch lists, payment tracking, and more, our mobile app puts the auction in their pocket—anytime, anywhere.
          </p>
        </div>
      </section>

      <section className="product-card">
        <div className="product-info">
          <h2>Google Chrome Extension</h2>
          <p>
            Our Chrome extension gives your dealers seamless access to Copart and IAAI auctions right from their desktop browser. Place bids, track watch lists, monitor payments, and stay updated in real-time—all from a lightweight, easy-to-use interface.
          </p>
        </div>
        <img src="/static/03.png" alt="Chrome Extension" className="product-image" />
      </section>
    </div>
  );
};

export default ProductsPage;
